var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible(_vm.item))?_c('button',{staticClass:"button is-small smaller darker is-success",class:{
    'is-loading': _vm.working(_vm.item)
  },attrs:{"disabled":_vm.working(_vm.item) || _vm.item.changingVersion},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" Install ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }